import { api } from '../api';

export const publipostService = {
  async fetchSharePubliposts(params, cancelToken) {
    return api.get('publiposts/share', { params, cancelToken: cancelToken.token });
  },

  async fetchPublipostsLinks(params) {
    return api.get('publiposts/links', { params });
  },

  async fetchPubliposts(params, cancelToken) {
    return api.get('publiposts', { params, cancelToken: cancelToken.token });
  },

  async fetchStepPubliposts(params, cancelToken) {
    return api.get('publiposts/step', { params, cancelToken: cancelToken.token });
  },

  async fetchPublipost(id) {
    return api.get('publiposts/' + id);
  },

  async createPublipost(params) {
    return api.post('publiposts', params);
  },

  async updatePublipost(id, params) {
    return api.post('publiposts/' + id, { '_method': 'PUT', ...params });
  },

  async uploadAttachment(params) {
    return api.post('publiposts/attachment', params);
  },

  async generateUrl(params) {
    return api.post('publiposts/share/generate-url', params);
  },

  async reportPublipost(id, params) {
    return api.post('publiposts/' + id + '/report', params);
  },

  async searchImages(params, cancelToken) {
    return api.get('publiposts/search/images', { params, cancelToken: cancelToken.token });
  },

  async checkPublipost(params,) {
    return api.post('publiposts/check', params);
  },

  async fetchPublipostsRequests(params) {
    return api.get('publiposts/requests', { params });
  },

  async fetchPublipostRequest(id) {
    return api.get('publiposts/requests/' + id);
  },
  
  async createPublipostRequest(params) {
    return api.post('publiposts/requests', params);
  },

  async updatePublipostRequest(id, params) {
    return api.post('publiposts/requests/' + id, { '_method': 'PUT', ...params });
  },

  async catchPublipostRequest(id) {
    return api.put('publiposts/requests/' + id + '/catch');
  },

  async generatePublipost(params,) {
    return api.post('publiposts/generate', params);
  },
};